import { FC } from 'react';
import { AudienceInsightsErrorBoundary } from '../errorBoundary';
import { BehaviorQueryContextProvider } from './behaviorQuery';
import { CustomBehavioralContextProvider } from './customBehavior';
import { ConversionInsightsContextProvider } from './conversionInsights';

export const BehaviorInsightsContextProvider: FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => (
  <AudienceInsightsErrorBoundary isSection>
    <BehaviorQueryContextProvider>
      <CustomBehavioralContextProvider>
        <ConversionInsightsContextProvider>{children}</ConversionInsightsContextProvider>
      </CustomBehavioralContextProvider>
    </BehaviorQueryContextProvider>
  </AudienceInsightsErrorBoundary>
);
